import { render, staticRenderFns } from "./CreateDespesas.vue?vue&type=template&id=525e94e9"
import script from "./CreateDespesas.vue?vue&type=script&lang=js"
export * from "./CreateDespesas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports